import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: 'primario' | 'secundario' | 'texto';
  cargando?: boolean;
  children: ReactNode;
};

const estilos = {
  // Texto MARINO sobre el naranja: blanco sobre #FF6C0D da 2,84:1 de contraste,
  // por debajo del minimo accesible. Marino oscuro da 5,50:1, y ademas es lo que
  // hace el logo -- naranja sobre marino, nunca blanco sobre naranja.
  primario:
    'bg-naranja-500 text-marino-900 shadow-sm hover:bg-naranja-400 active:bg-naranja-600 disabled:hover:bg-naranja-500',
  secundario:
    'border border-marino-200 bg-white text-marino-700 hover:bg-marino-50 disabled:hover:bg-white',
  texto: 'bg-transparent text-marino-600 hover:text-naranja-600 hover:underline',
} as const;

export function Boton({
  variante = 'primario',
  cargando,
  children,
  // ⚠️ `className` se saca del resto A PROPÓSITO y se concatena abajo.
  // Estaba dentro del spread, y como el spread va después del atributo
  // `className`, un `className` pasado desde fuera reemplazaba TODO el estilo
  // interno —incluido el fondo naranja— y el botón quedaba invisible: texto
  // blanco sobre fondo blanco. No daba error ni warning.
  className = '',
  ...resto
}: Props) {
  return (
    <button
      {...resto}
      // Un botón que dispara una petición y no se deshabilita produce dos
      // peticiones: la gente hace doble clic cuando no ve respuesta.
      disabled={cargando || resto.disabled}
      aria-busy={cargando || undefined}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3
        font-semibold transition disabled:cursor-not-allowed disabled:opacity-60
        ${estilos[variante]} ${className}`}
    >
      {cargando && (
        <span
          aria-hidden="true"
          className="h-4 w-4 animate-spin rounded-full border-2 border-current/30 border-t-current"
        />
      )}
      {children}
    </button>
  );
}
